// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2VNG6","footer":"styles_footer__3ar-8","passCodeTooltip":"styles_passCodeTooltip__21xcd"};